import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import FmStorageEditService from 'app/admin/fileManager/service/FmStorageEditService';
import EditFormSubComponent from 'modules/ui/editform/subForm/EditFormSubComponent';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormRadioGroupField from 'modules/ui/editform/fields/EditFormRadioGroupField';

const config = {
	key: 'fmStorageEditForm',
	text: 'Megosztott mappa',
	textKey: 'fm-storage',
	service: FmStorageEditService,
	watchTitleKey: 'fileName',
	tabList: [
		{
			key: 'basic',
			text: 'Megosztás információk',
			textKey: 'basic'
		},
		{
			key: 'permissionList',
			text: 'Engedély szerkesztése',
			textKey: 'parameterList'
		}
	],
	fields: [
		{
			key: 'fileName',
			text: 'Név',
			textKey: 'fileName',
			tab: 0,
			component: EditFormTextField,
			required: true
		},
		{
			key: 'permissionList',
			text: 'Engedély szerkesztése',
			textKey: 'permissionList',
			tab: 1,
			component: EditFormSubComponent,
			defaultValue: {
				id: null,
				key: null,
				name: null,
				user: null,
				userGroup: null,
				grantedLevel: null
			},
			fields: [
				{
					key: 'user',
					text: 'Felhasználó',
					textKey: 'user',
					component: EditFormSelectField,
					required: true,
					items: () => FmStorageEditService.getPermissionListUserSelection()
				},
				{
					key: 'grantedLevel',
					text: 'Jogosultság',
					textKey: 'grantedLevel',
					component: EditFormRadioGroupField,
					required: true,
					type: 'enum',
					items: [
						{
							label: 'Csak olvasható',
							value: 'ReadOnly'
						},
						{
							label: 'Írás-olvasás',
							value: 'WriteRead'
						},
						{
							label: 'Hozzáférés megtagadva',
							value: 'Deny'
						}
					]
				}
			]
		}
	]
};

function FmStorageEditForm() {
	return <EditFormPage config={config} />;
}

export default FmStorageEditForm;
